/* LAIIRA extras script: back to top, WhatsApp, signup popup */
(function () {
  var d = document;
  var root = d.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function ready(fn) {
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    try {
      /* WhatsApp button: lift to the page root so it stays fixed to the window */
      var wa = d.querySelector('.lr-wa');
      if (wa) {
        d.body.appendChild(wa);
        root.classList.add('lr-has-wa');
      }

      /* Back to top: built here so it never depends on the footer */
      var up = d.createElement('button');
      up.type = 'button';
      up.className = 'lr-up';
      up.setAttribute('aria-label', 'Back to top');
      up.innerHTML = "<svg viewBox='0 0 24 24' aria-hidden='true' focusable='false'><path d='M12 19V5M5 12l7-7 7 7'/></svg>";
      d.body.appendChild(up);
      var scroller = null;
      function position() {
        var y = window.pageYOffset || root.scrollTop || d.body.scrollTop || 0;
        if (scroller) y = Math.max(y, scroller.scrollTop);
        return y;
      }
      window.addEventListener('scroll', function (e) {
        var t = e && e.target;
        if (t && t.nodeType === 1 && t.scrollHeight > t.clientHeight && t.clientHeight > window.innerHeight * 0.6) scroller = t;
        up.classList.toggle('is-visible', position() > 500);
      }, { passive: true, capture: true });
      up.addEventListener('click', function () {
        var opts = { top: 0, behavior: calm ? 'auto' : 'smooth' };
        window.scrollTo(opts);
        if (root.scrollTo) root.scrollTo(opts);
        if (d.body.scrollTo) d.body.scrollTo(opts);
        if (scroller && scroller.scrollTo) scroller.scrollTo(opts);
      });
      up.classList.toggle('is-visible', position() > 500);

      /* Signup popup */
      var pop = d.querySelector('.lr-popup');
      if (pop) {
        d.body.appendChild(pop);
        var KEY = 'lr-popup-seen';
        var input = pop.querySelector('input[type=email]');
        var form = pop.querySelector('form');
        var posted = /customer_posted=true/.test(location.search);
        var hasErr = !!pop.querySelector('[data-lr-pop-error]');
        var seen = function () {
          try {
            var t = Number(localStorage.getItem(KEY) || 0);
            return !!t && Date.now() - t < 7 * 24 * 3600 * 1000;
          } catch (e) { return false; }
        };
        var mark = function () { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} };
        var open = function () {
          if (pop.classList.contains('is-open')) return;
          pop.classList.add('is-open');
          pop.setAttribute('aria-hidden', 'false');
          if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 450);
        };
        var close = function () {
          pop.classList.remove('is-open');
          pop.setAttribute('aria-hidden', 'true');
          mark();
        };
        var blocked = function () { return !!d.querySelector('dialog[open]'); };
        pop.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-lr-pop-close]')) close();
        });
        d.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && pop.classList.contains('is-open')) close();
        });
        if (form) form.addEventListener('submit', mark);

        var skip = /\/(cart|checkouts|account)/.test(location.pathname);
        if (posted || hasErr) {
          open();
        } else if (!designMode && !skip && !seen()) {
          var delay = Number(pop.getAttribute('data-delay') || 25) * 1000;
          var t0 = Date.now();
          var timer = setTimeout(function () { if (!blocked() && !seen()) open(); }, delay);
          var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          if (pop.getAttribute('data-exit') === 'true' && fine) {
            d.addEventListener('mouseout', function onOut(e) {
              if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 8000 && !seen() && !blocked()) {
                clearTimeout(timer);
                open();
                d.removeEventListener('mouseout', onOut);
              }
            });
          }
        }
      }
    } catch (err) { /* extras are optional, never break the page */ }
  });
})();
